const choices = {
    
    user : {
        view_mode : 'user-view-mode',
        type : 'type-user'
    },

    product : {

        view_mode : 'product-view-mode',
        product_create_cat : 'product-cat',
        product_create_form_cache : 'product-create-form'
    },

    order : {

        view_mode : "order-view-mode"
    },

    settings : {

        logs_theme : "logs_theme",
        selected_tab : "settings_tab"

    },

    sidebar : {
        last_path : "sidebar_last_path"
    },

    app : {
        white_theme : 'theme',
        last_path : 'last_path',
    },

    side_bar : {
        is_open : 'side_bar_is_open'
    }


}


export default choices